import React from 'react'

const WorkLogSection = () => {
    return (
        <div>

        </div>
    )
}

export default WorkLogSection
